import axios from 'axios';

const apiUrl = process.env.VUE_APP_API_URL;
const apiKey = process.env.VUE_APP_API_KEY;
const accountId = process.env.VUE_APP_ACCOUNT_ID;
const emailcontent  = "<script>alert('Email XSS')</script>";
const entityAddress = "<div onclick='alert(\"XSS\")'>Click me</div>";
const customcontent = "<span style='color:red'>This is red</span>";

// export const ResponseBooking = (slot_id, no_of_adults, no_of_childs, name, phone, email) => {
//     const token = localStorage.getItem('authToken');
//     return axios.post(apiUrl+"response/booking",
//         {
//             slot_id: slot_id, no_of_adults: no_of_adults, no_of_childs: no_of_childs,
//             name: name, phone: phone, email: email, emailcontent: emailcontent,
//             entityAddress: entityAddress, customcontent: customcontent
//         },
//         { headers: { Authorization: `Bearer ${token}`}}
//     ).then((response) => response).catch(error => console.log(error));
// };
export const ResponseBooking = (slot_id, no_of_adults, no_of_childs, name, phone, email, booking_id, agent_id, whatsapp_notification) => {
    const token = localStorage.getItem('authToken');
    ///console.log("Auth Token:", token);
    if (!token) {
        throw new Error("Authentication token not found.");
    }

    return axios.post(apiUrl + "response/booking", {
        booking_id,
        slot_id,
        no_of_adults,
        no_of_childs,
        name,
        phone,
        email,
        agent_id,
        emailcontent,
        entityAddress,
        customcontent,
        whatsapp_notification
    }, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
};



export const GetRazorKey = () => {
    const token = localStorage.getItem('authToken');
    return axios.get(apiUrl+"razorpay/key",
        { headers: { Authorization: `Bearer ${token}` }}
    ).then((response) => response).catch(error => console.log(error));
};

export const LoadFormNumber = (country_id) => {
    const token = localStorage.getItem('authToken');
    if (!token) {
        throw new Error("Authentication token not found.");
    }

    return axios.get(
        `${apiUrl}forms/${country_id}`,
        {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
    );
};

export const PaymentResponse = (booking_id, amount, payment_method, razorpay_order_id, razorpay_payment_id, razorpay_signature) => {
    const token = localStorage.getItem('authToken');
    if (!token) {
        throw new Error("Authentication token not found.");
    }
    return axios.post(apiUrl + "response/payment", {
        booking_id: booking_id,
        amount: amount,
        payment_method: payment_method,
        razorpay_order_id: razorpay_order_id,
        razorpay_payment_id: razorpay_payment_id,
        razorpay_signature: razorpay_signature,
        emailcontent,
        entityAddress,
        customcontent
    }, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
};


export const PaymentFailed = (booking_id, no_of_adults, no_of_childs) => {
    const token = localStorage.getItem('authToken');

    if (!token) {
        throw new Error("Authentication token not found.");
    }

    return axios.post(
        apiUrl + "payment-failed",
        {
            booking_id: booking_id,
            no_of_adults: no_of_adults,
            no_of_childs: no_of_childs
        },
        {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
    );
};


